import type { SyncCursorInfo } from "../../api/admin-content";
import { tableStyles as ts } from "../../components/TableParts";
import { t } from "../../i18n";
import { formatDate, shortId } from "./storage-detail-formatters";

export function StorageSyncCursorTable({
  cursors,
}: {
  cursors: ReadonlyArray<SyncCursorInfo>;
}): React.JSX.Element {
  if (cursors.length === 0) {
    return <p style={ts.emptyText}>{t("storage_detail.no_sync_cursors")}</p>;
  }
  return (
    <table style={ts.table}>
      <thead>
        <tr>
          <th style={ts.th}>{t("storage_detail.col_device")}</th>
          <th style={ts.th}>{t("storage_detail.col_conversation")}</th>
          <th style={ts.th}>{t("storage_detail.col_last_seq")}</th>
          <th style={ts.th}>{t("storage_detail.col_synced_at")}</th>
        </tr>
      </thead>
      <tbody>
        {cursors.map((cursor) => (
          <tr
            key={`${cursor.device_id}:${cursor.conversation_id}`}
            style={ts.row}
          >
            <td style={ts.td}>
              <span style={styles.mono}>{shortId(cursor.device_id)}</span>
            </td>
            <td style={ts.td}>
              <span style={styles.mono}>{shortId(cursor.conversation_id)}</span>
            </td>
            <td style={ts.td}>{cursor.last_seq}</td>
            <td style={ts.td}>{formatDate(cursor.synced_at)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

const styles: Record<string, React.CSSProperties> = {
  mono: { fontFamily: "monospace", fontSize: 12 },
};
